// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d456ce70","455":"e4e9d0b0","977":"f71b7a63"}[chunkId] + ".chunk.js";
};